/// <reference path="../../_ext/Editors/BOMGridEditor.ts" />

namespace TabAurous.ProductDevelopment {
    import fld = DesignRequestBOMRow.Fields;

    @Serenity.Decorators.registerClass()
    export class DesignRequestBOMEditor extends _Ext.GridEditorBase<DesignRequestBOMRow> {
        protected getDialogType() { return DesignRequestBOMDialog; }
        
        protected getColumnsKey() { return "ProductDevelopment.RequirementStoneItems"; }

        protected getLocalTextPrefix() { return DesignRequestBOMRow.localTextPrefix; }
        constructor(container: JQuery) {
            super(container); 
            this.slickGrid.setOptions({ rowHeight: 30 }); 
        }

        public setData(bomvalues: any[]) {

            this.view.setItems([], false);
            var tmp = [];
            for (let bom of bomvalues) {
                bom.BOMProductId = bom.BOMDesignId;
                delete bom.BomId;
                delete bom.DesignId;
                delete bom.BOMDesignId;
                delete bom.CenterStone;
                delete bom.Sys_Date;
                bom[this.getIdProperty()] = "`" + this.nextId++;
                this.view.addItem(bom);
            }
            return tmp;

        }
        validateEntity(row: DesignRequestBOMRow, id) { 
            row.ProductTypeName = OMS.ProductTypeRow.getLookup().itemById[row.ProductTypeId].ProductTypeCode;
            if (row.ItemTypeId == 105) {
                var quality = OMS.AttributeMasterRow.getLookup().itemById[row.QualityId];
                row.QualityName = quality.AttributeName;
                row.QualityCode = quality.AttributeCode;
                var shape = OMS.AttributeMasterRow.getLookup().itemById[row.ShapeId];
                row.ShapeName = shape.AttributeName;
                row.ShapeCode = shape.AttributeCode;
                var stone = OMS.AttributeMasterRow.getLookup().itemById[row.StoneColorId];
                row.StoneColoreName = stone.AttributeName;
                row.StoneColorCode = stone.AttributeCode;
            }
            row.PureWeight = 0;
            row.Parts = 1;
            row.TextureId = 0;
            return true;
        }

        //protected getButtons() {
        //    let buttons = super.getButtons();

        //    buttons.push({
        //        title: "Select BOM",
        //        cssClass: "add-button",
        //        onClick: () => {

        //            // **** Validate Party before Item Selection ****


        //            var grid = Common.ProductSelectGrid;
        //            var filters: _Ext.SelectGridFilters = {
        //                FilterItems: 4
        //            }

        //            var pickerDialog = new _Ext.GridItemPickerDialog({
        //                gridType: grid, multiple: true,
        //                preSelectedKeys: this.value.map(k => k.ProductId), GridFilters: filters
        //            });
        //            pickerDialog.onSuccess = (selectedItems: OMS.ProductMasterRow[]) => {
        //                selectedItems = selectedItems.filter(x => x != undefined);
        //                let selectedItems2 = selectedItems.filter(t => { return !Q.any(this.view.getItems(), n => n.ProductId == t.ProductId && n.BOMAttributeId == t.AttributeId) });
        //                var self = this;
        //                var details = [];
        //                let lineno;
        //                // #region Items to Grid
        //                //for (let value of selectedItems2)
        //                selectedItems2.forEach(function (value: OMS.ProductMasterRow) {
        //                    var oldbom = value;
        //                    var bom: DesignRequestBOMRow = {
        //                        ProductCode: oldbom.ProductCode,
        //                        BOMProductId: oldbom.ProductId,
        //                        BOMAttributeId: oldbom.AttributeId,
        //                        CalcOnId: oldbom.CalcOnId,
        //                        Pieces: oldbom.Pieces,
        //                        Weight: oldbom.Weight,
        //                        ItemType: oldbom.ItemType,
        //                        ItemTypeId: oldbom.ItemTypeId,
        //                        StoneColorId: oldbom.StoneColorId,
        //                        Attribute: oldbom.Attribute,
        //                        CategoryId: oldbom.CategoryId,
        //                        SubCategoryId: oldbom.SubCategoryId,
        //                        ProductTypeId: oldbom.ProductTypeId,
        //                        QualityId: oldbom.QualityId,
        //                        SieveId: oldbom.SieveId,
        //                        ShapeId: oldbom.ShapeId,
        //                        StoneSizeId: oldbom.StoneSizeId,
        //                        SettingId: oldbom.SettingId,
        //                        StoneCuletId: oldbom.StoneCuletId,
        //                        StoneCutId: oldbom.StoneCutId,
        //                        StoneFluorescenceId: oldbom.StoneFluorescenceId,
        //                        StoneGirdleId: oldbom.StoneGirdleId,
        //                        StonePolishId: oldbom.StonePolishId,
        //                        StoneSymmetryId: oldbom.StoneSymmetryId,
        //                        StoneDepth: oldbom.StoneDepth,
        //                        StoneTable: oldbom.StoneTable,

        //                        KaratId: oldbom.KaratId,
        //                        MetalColorId: oldbom.MetalColorId,
        //                        Purity: oldbom.Purity,
        //                        PureWeight: oldbom.Purity * oldbom.Weight,
        //                    };

        //                    details.push(bom);


        //                    for (let Detail of details) {
        //                        Detail[self.getIdProperty()] = "`" + self.nextId++;
        //                        self.view.addItem(Detail);
        //                    }


        //                });
        //            }
        //            pickerDialog.dialogOpen();

        //        }
        //    });

        //    return buttons;
        //}

    }
}